import React, { Component } from 'react';
import { Button, Table, Input } from 'reactstrap';
// import Delete from '../../../res/letter-x.png';

/*
Ability to hover over task and edit table (must give warning modal).
Ability to add new row. - DONE
Connection to Firebase. - DONE
Profit and Loss etc. - DONE
*/

class TradeTable extends Component {
    state = {
        information: {
            company: this.props.name,
            type: this.props.type,
            name: '',
            amount: null,
            price: 0,
        },
        empty: {
            name: true,
            amount: true,
            price: true,
        },
        submitted: false,
        addOrderVisible: false,
    };

    formatNumber = (x) => {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    };

    handleChange = (field, value) => {
        this.setState({
            information: {
                ...this.state.information, // might cause a bug, change to prev state later
                [field]: value,
            },
            empty: {
                ...this.state.empty,
                [field]: !(value.toString().length > 0),
            },
            submitted: false,
        });
    };

    addTrade = () => {
        this.setState({
            submitted: true,
        });

        if (!this.state.empty.name && !this.state.empty.amount && !this.state.empty.price) {
            let data = this.state.information;
            data.company = this.props.name;

            this.props.newRecord(data, this.props.type);
            this.resetTrade();
        }
    };

    cancelTrade = () => {
        this.props.activate(this.props.type, false);
        this.resetTrade();
    };

    resetTrade = () => {
        this.setState({
            information: {
                company: this.props.name,
                type: this.props.type,
                name: '',
                amount: null,
                price: 0,
            },
            empty: {
                name: true,
                amount: true,
                price: true,
            },
            submitted: false,
        });
    };

    removeTrade = (information) => {
        this.props.removeTrade({
            ...information,
            company: this.props.name,
            type: this.props.type,
        });
    };

    calculateValue = (amount, price) => {
        // remove any ',' from the amount value
        amount = parseInt(amount.toString().replace(/\W/g, ''));
        return this.formatNumber((amount * price).toFixed(2));
    };

    render() {
        
        const tableRows = [];

        const data = this.props.data;

        const inputCSS = { 
        padding: '5px 0px 15px 0px', 
        border: 'none', 
        background: 'transparent', 
        color: 'white',
        fontSize: '1em', 
        borderRadius: 0, 
        borderBottom: '1px solid #70B7FF',
        marginRight: 10};

        const tdCSS = { padding: 5, fontSize: '0.9em' }
        const buttonCSS = { fontSize: '0.8em', padding: '5px 15px' }
        const emptyTd = { padding: 0, borderTop: 'none', borderBottom: 'none'}

        var today = new Date();
        var dd = String(today.getDate()).padStart(2, '0');
        var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
        var yyyy = today.getFullYear();

        today = mm + '/' + dd + '/' + yyyy;

        if (data) {
            for (const entry of Object.entries(data)) {
                const information = entry[1];

                tableRows.push(
                    <tr key={entry[0]}>
                        <td style={tdCSS}>{ today }</td>
                        <td style={tdCSS}>{ (information.name === '') ? 'CLOB' : 'OTC' }</td>
                        <td style={tdCSS}>{ (information.name === '') ? '-- --' : information.name }</td>
                        <td style={tdCSS}>{ this.formatNumber(information.amount) }</td>
                        <td style={tdCSS}>$ { parseFloat(information.price).toFixed(2) }</td>
                        <td style={tdCSS}>$
                            {this.formatNumber(
                                parseFloat(
                                    information.amount * information.price,
                                ).toFixed(2),
                            )}
                        </td>
                        <td style={tdCSS}><span className="approved">Approved</span></td>
                    </tr>
                );
            }
        }

        return (
            <div className="trade-table">
                <div className="trade-header">
                    <span className={this.props.type}>
                        {this.props.type.toUpperCase()}
                    </span>
                </div>
                { this.state.addOrderVisible ?
                <div className="tradeOrder" style={(this.props.type === 'sell') ? {marginLeft: 10} : {}}>
                    <span className="otc-order">OTC Order</span>
                    <Input style={inputCSS} className={
                        this.state.submitted &&
                        this.state.empty.name
                            ? 'animated pulse faster'
                            : ''
                    }
                    value={
                        this.state.information.name != null
                            ? this.state.information.name
                            : ''
                    }
                    placeholder="Name"
                    onChange={(e) =>
                        this.handleChange('name', e.target.value)
                    }/>
                    <Input style={inputCSS} className={
                        this.state.submitted &&
                        this.state.empty.amount
                            ? 'animated pulse faster'
                            : ''
                    }
                    placeholder={
                        '# ' +
                        (this.props.type === 'buy'
                            ? 'Bought'
                            : 'Sold')
                    }
                    value={
                        this.state.information.amount != null
                            ? this.state.information.amount
                            : ''
                    }
                    onChange={(e) =>
                        !isNaN(e.target.value)
                            ? this.handleChange(
                                    'amount',
                                    e.target.value,
                                )
                            : ''
                    }/>
                    <Input style={inputCSS} type='text' className={
                        this.state.submitted &&
                        this.state.empty.price
                            ? 'animated pulse faster'
                            : ''
                    }
                    placeholder="Price"
                    value={
                        this.state.information.price !== 0
                            ? this.state.information.price
                            : ''
                    }
                    onChange={(e) =>
                        !isNaN(
                            e.target.value
                                .toString()
                                .replace('$', ''),
                        )
                            ? this.handleChange(
                                    'price',
                                    e.target.value
                                        .toString()
                                        .replace('$', ''),
                                )
                            : ''
                    }/>
                    <span className="tableLabel">${this.state.information.amount > 0 &&
                        this.state.information.price > 0
                            ? this.calculateValue(
                                    this.state.information.amount,
                                    this.state.information.price,
                                )
                            : '0.00'}</span>
                    <Button
                    outline
                        style={buttonCSS}
                        color="primary"
                        onClick={(e) => this.addTrade()}>
                        Add
                    </Button>
                </div>
                : <Button
                outline
                style={{...buttonCSS, margin: '10px 0px 10px 0px', position: 'absolute', top: '6px'}}
                color="primary"
                onClick={(e) => this.setState({ addOrderVisible: true })}>
                Add OTC Order
                </Button> }
                <Table>
                    <thead>
                        <tr>
                            <th style={{ border: 'none' }}>
                                Date
                            </th>
                            <th style={{ border: 'none' }}>
                                Type
                            </th>
                            <th style={{ border: 'none' }}>
                                Counterparty
                            </th>
                            <th style={{ border: 'none' }}>
                                #{' '}
                                {this.props.type === 'buy' ? 'Bought' : 'Sold'}
                            </th>
                            <th style={{ border: 'none' }}>
                                Price
                            </th>
                            <th style={{ border: 'none' }}>
                                Value
                            </th>
                            <th style={{ border: 'none' }}>
                                Status
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        { (tableRows.length > 0) ? tableRows : <tr><td style={emptyTd}><span className='emptyTable'>No orders yet.</span></td></tr> }
                    </tbody>
                </Table>
            </div>
        );
    }
}

export default TradeTable;
